import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var UserInformationSvg = function UserInformationSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.096 3.611a4.7 4.7 0 0 1 3.318-1.362c1.244 0 2.437.49 3.317 1.362a4.63 4.63 0 0 1 1.374 3.29 4.63 4.63 0 0 1-1.374 3.288 4.7 4.7 0 0 1-3.317 1.362 4.7 4.7 0 0 1-3.318-1.362A4.63 4.63 0 0 1 6.722 6.9c0-1.233.494-2.416 1.374-3.289m3.318.033c-.871 0-1.707.343-2.323.954A3.24 3.24 0 0 0 8.13 6.9c0 .864.346 1.692.961 2.302.616.611 1.452.954 2.323.954.87 0 1.706-.343 2.322-.954.615-.61.961-1.438.961-2.302 0-.863-.345-1.691-.961-2.302a3.3 3.3 0 0 0-2.322-.954",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.907 16.107v1.49h8.68v1.396H2.5v-3.712l.361-.2a17.17 17.17 0 0 1 8.319-2.134c1.698 0 3.34.245 4.891.703l-.402 1.337a15.8 15.8 0 0 0-4.49-.645h-.001a15.75 15.75 0 0 0-7.27 1.765M18.45 14.11v1.395h1.408v-1.396zM19.858 16.203h-3.05v1.395h1.643v3.256h-1.642v1.395H21.5v-1.395h-1.642z"
  }));
};
export var UserInformation = function UserInformation(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: UserInformationSvg
  }));
};